<template>
<div id="create-puzzle">
  <h2>Upload New Puzzle</h2>

  <puzzle-upload
    v-on:source-file-not-player-compatible="onSourceFileChange"
    v-on:puzzle-imported="onPuzzleImported"
  />

</div>
</template>

<script>
import PuzzleUpload from '@/components/PuzzleUpload'

export default {
  components: {
    'puzzle-upload': PuzzleUpload
  },

  methods: {
    onPuzzleImported (puzzle) {
      this.$emit('puzzle-imported', puzzle)
    },

    onSourceFileChange (ev) {
      this.$emit('source-file-not-player-compatible', ev)
    }
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PuzzleCreate.vue